import {
    OrderSummary as ModOrderSummary,
    OrderSummaryProps
} from 'mod/order/OrderSummary';
import cn from 'classnames';
import styles from './index.module.less';

export const OrderSummary: React.FC<OrderSummaryProps> = ({ className, ...props }) => (
    <ModOrderSummary
        className={cn(className, styles.summary)}
        {...props}
    />
)
